import React, { Component } from 'react';
import {PropTypes} from 'prop-types';
import {Conversations} from 'api';
import {DateTime} from 'components/UI/DateTime';
import truncate from 'lodash/truncate';
import {Link, withRouter} from 'react-router-dom';
import {MessageItem} from 'components/conversations';
import BusinessMessageHeading from './partials/BusinessMessageHeading.jsx';
import UserMessageHeading from './partials/UserMessageHeading.jsx';
import {connect} from 'react-redux';
import style from './_list.scss';

class ConversationsContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      conversation: this.props.conversation,
      messages: []
    }
  }

  componentDidMount() {
    this.loadMessages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.conversation != this.state.conversation) {
      this.setState({
        conversation: nextProps.conversation
      });

      this.loadMessages();
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'CLEAN_CONVERSATION'
    });
  }

  loadMessages() {
    this.props.dispatch(Conversations.actions.messages({
      id: this.state.conversation.id,
      filter: {
        include: 'user'
      }
    }))
    .then(response => {
      this.props.dispatch({
        type: 'LIST_CONVERSATION_MESSAGES',
        messages: response.data
      });
    });
  }

  render() {
    return (
      <div className='need-offer-list-comment'>
        {
          this.props.messages.map(message => {
            return (
              <MessageItem message={message}
                isMe={message.user.id == this.props.auth.user.id}
                isUserView={(this.props.view === 'BUSINESS')}
                customHeading={() => {
                  if (this.props.view === 'USER')
                  return <BusinessMessageHeading
                    business={message.user.mainBusiness}
                    message={message}
                         />

                  if (this.props.view === 'BUSINESS')
                  return <UserMessageHeading
                    user={message.user}
                    message={message}
                         />
                }

                }
              />
            )
          })
        }
      </div>
    );
  }

}

ConversationsContainer.propTypes = {
  view: PropTypes.oneOf(['BUSINESS', 'USER'])
}

ConversationsContainer.defaultProps = {
  view: 'USER'
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    messages: state.conversationMessages || []
  }
}

export default connect(mapStateToProps)(ConversationsContainer);



// WEBPACK FOOTER //
// ./components/conversations/Container.jsx